import {ENV} from "../../env";

class EnvHelper {
    static isProd() {
        return ENV === "default";
    }
    
    static isQA() {
        return ENV === "qa";
    }

    static isTestEnv(){
        return !EnvHelper.isProd();
    }
}

export default EnvHelper;
